import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import clanakService from "../../services/clanak.service";
import SearchBar from "../../components/SearchBar";
import { Button, Dropdown, Menu, Space, Row, Col } from "antd";
import {
  MenuOutlined,
  TableOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import ConfirmDeleteModal from "../../components/ConfirmDeletModal";
import { useNavigate } from "react-router-dom";
import ClanakCards from "./ClanakCards";
import ClanakList from "./ClanakList";
import "./ClanakPage.css";
import "../Dokument/DokumentsPage.css";
import "../Dokument//DokumentsPageKorisnik.css";
import Background from "../../components/Background4";
import kategorijaClankaService from "../../services/kategorijaClanka.service";
function ClanakPage() {
  const [clanci, setClanci] = useState([]);
  const [searchTitle, setSearchTitle] = useState("");
  const [selectedClanakId, setSelectedClanakId] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isListView, setListView] = useState(true);
  const [kategorijaClanka, setKategorijaClanka] = useState(null);

  const [sortCriteria, setSortCriteria] = useState("datumObjave");
  const [sortOrder, setSortOrder] = useState("asc");

  const { kategorijaClankaId } = useParams();

  const navigate = useNavigate();

  const showDeleteModal = (id) => {
    setSelectedClanakId(id);
    setIsDeleteModalVisible(true);
  };

  const fetchClanci = useCallback(async () => {
    try {
      let result;
      if (kategorijaClankaId) {
        let kategorija = await kategorijaClankaService.getById(
          kategorijaClankaId
        );
        setKategorijaClanka(kategorija.data);
        result = await clanakService.getClanciByKategorijaId(
          kategorijaClankaId
        );
      } else {
        result = await clanakService.getAll();
      }
      setClanci(result.data);
    } catch (error) {}
  }, [kategorijaClankaId]);

  const filtriraniClanci = clanci.filter((clanak) =>
    clanak.naslov.toLowerCase().includes(searchTitle.toLowerCase())
  );

  const sortArticles = (articles) => {
    return articles.sort((a, b) => {
      let comparison = 0;
      if (sortCriteria === "datumObjave") {
        comparison = new Date(a.datumObjave) - new Date(b.datumObjave);
      } else if (sortCriteria === "naslov") {
        comparison = a.naslov.localeCompare(b.naslov);
      } else if (sortCriteria === "autor") {
        comparison = a.autor.localeCompare(b.autor);
      }
      return sortOrder === "asc" ? comparison : -comparison;
    });
  };

  const sortedClanci = sortArticles([...filtriraniClanci]);

  useEffect(() => {
    fetchClanci();
  }, [fetchClanci]);

  const handleDelete = async () => {
    if (selectedClanakId === null) return;
    try {
      await clanakService.deleteClanak(selectedClanakId);
      setClanci((prev) =>
        prev.filter((clanak) => clanak.id !== selectedClanakId)
      );
    } catch (error) {
    } finally {
      setIsDeleteModalVisible(false);
      setSelectedClanakId(null);
    }
  };

  const onUpdateClick = (id) => {
    navigate(`/zaposleni/clanci/${id}/edit`);
  };

  //const sortedClanci = sortArticles([...clanci]);
  const sortMenu = (
    <Menu onClick={(e) => setSortCriteria(e.key)}>
      <Menu.Item key="datumObjave">Datum Objave</Menu.Item>
      <Menu.Item key="naslov">Naslov</Menu.Item>
      <Menu.Item key="autor">Autor</Menu.Item>
    </Menu>
  );

  return (
    <div>
      <Background />
      <div className="docs-border">
        <div className="docs-container">
          <Row justify="center" align="middle" style={{ width: "90%" }}>
            <Col span={24}>
              <div className="page-title-and-search">
                <h1 className="page-title">
                  {kategorijaClanka ? kategorijaClanka.naziv : "Svi članci"}
                </h1>
                <SearchBar
                  searchTitle={searchTitle}
                  setSearchTitle={setSearchTitle}
                />
              </div>
            </Col>
          </Row>

          <div className="AddButton-HeaderButton">
            <Row style={{ width: "100%" }}>
              <Col
                span={24}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  type="primary"
                  onClick={() => navigate("/zaposleni/dodaj-clanak")}
                >
                  Dodaj novi članak
                </Button>
              </Col>
            </Row>
            <Row style={{ width: "100%" }}>
              <Col
                span={24}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Space>
                  <Button
                    icon={isListView ? <TableOutlined /> : <MenuOutlined />}
                    onClick={() => setListView(!isListView)}
                  />
                  <Button
                    onClick={() =>
                      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                    }
                  >
                    {sortOrder === "asc" ? <UpOutlined /> : <DownOutlined />}
                  </Button>
                  <Dropdown overlay={sortMenu} trigger={["click"]}>
                    <Button>
                      Sortiraj
                      <DownOutlined />
                    </Button>
                  </Dropdown>
                </Space>
              </Col>
            </Row>
          </div>

          <div className="dokument-list-div">
            {isListView ? (
              <ClanakList
                clanci={sortedClanci}
                onDeleteClick={showDeleteModal}
                setClanci={setClanci}
                onEditClick={onUpdateClick}
              />
            ) : (
              <ClanakCards
                clanci={sortedClanci}
                onDeleteClick={showDeleteModal}
                onEditClick={onUpdateClick}
              />
            )}
          </div>
          <ConfirmDeleteModal
            visible={isDeleteModalVisible}
            onConfirm={handleDelete}
            onCancel={() => setIsDeleteModalVisible(false)}
          />
        </div>
      </div>
    </div>
  );
}

export default ClanakPage;
